module.exports = __webpack_public_path__ + "static/media/bnr1.1c3a2129.jpg";